import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  justify-content: space-around;
  width: 100vw;
  margin-top: 32px;
`;

export const Column = styled.div`
  margin: 0 auto;
`;

export const FileContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-bottom: 20px;
  width: 512px;
  height: 128px;
  padding: 8px;
`;

export const InputLabel = styled.label`
  font-weight: 700;
  margin-bottom: 8px;
`;

export const Input = styled.input`
  padding: 10px;
  border: 2px solid var(--border-default);
  border-radius: 4px;
  font-size: 16px;
  outline: none;
  background: var(--input-bg);
  color: var(--text-primary);

  &::placeholder {
    color: var(--input-placeholder);
  }

  &:focus {
    border-color: var(--accent);
  }
`;

export const SmallText = styled.small`
  color: var(--text-muted);
  margin-bottom: 8px;
`;
